import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTAudioElement } from '@/types/slides'
import type { ContextmenuItem } from '@/components/Contextmenu/types'
import { VIEWPORT_SIZE } from '@/configs/canvas'

import AudioPlayer from './AudioPlayer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    elementInfo: {},
    selectElement: { type: Function },
    contextmenus: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { canvasScale, handleElementId } = storeToRefs(useMainStore())
const { viewportRatio } = storeToRefs(useSlidesStore())

const audioIconSize = computed(() => {
  return Math.min(props.elementInfo.width, props.elementInfo.height) + 'px'
})
const audioPlayerPosition = computed(() => {
  const canvasWidth = VIEWPORT_SIZE
  const canvasHeight = VIEWPORT_SIZE * viewportRatio.value

  const audioWidth = 280 / canvasScale.value
  const audioHeight = 50 / canvasScale.value

  const elWidth = props.elementInfo.width
  const elHeight = props.elementInfo.height
  const elLeft = props.elementInfo.left
  const elTop = props.elementInfo.top

  let left = 0
  let top = elHeight
  
  if (elLeft + audioWidth >= canvasWidth) left = elWidth - audioWidth
  if (elTop + elHeight + audioHeight >= canvasHeight) top = -audioHeight

  return {
    left: left + 'px',
    top: top + 'px',
  }
})

const handleSelectElement = (e: MouseEvent | TouchEvent) => {
  if (props.elementInfo.lock) return
  e.stopPropagation()

  props.selectElement(e, props.elementInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_IconVolumeNotice = _resolveComponent("IconVolumeNotice")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-audio", { 'lock': _ctx.elementInfo.lock }]),
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${_ctx.elementInfo.rotate}deg)` })
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "element-content",
        onMousedown: _cache[1] || (_cache[1] = $event => handleSelectElement($event)),
        onTouchstart: _cache[2] || (_cache[2] = $event => handleSelectElement($event))
      }, [
        _createVNode(_component_IconVolumeNotice, {
          class: "audio-icon",
          style: _normalizeStyle({
            fontSize: audioIconSize.value,
            color: _ctx.elementInfo.color,
          })
        }, null, 8, ["style"]),
        (_unref(handleElementId) === _ctx.elementInfo.id)
          ? (_openBlock(), _createBlock(AudioPlayer, {
              key: 0,
              class: "audio-player",
              style: _normalizeStyle({ ...audioPlayerPosition.value }),
              src: _ctx.elementInfo.src,
              loop: _ctx.elementInfo.loop,
              scale: _unref(canvasScale),
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["style", "src", "loop", "scale"]))
          : _createCommentVNode("", true)
      ], 32)), [
        [_directive_contextmenu, _ctx.contextmenus]
      ])
    ], 4)
  ], 6))
}
}

})